import React, { useEffect, useState, Suspense, lazy } from 'react';
import { useTranslation } from 'react-i18next';
import { colors } from '@material-ui/core';
import Label from 'src/components/Label';
import axios from 'src/utils/axios';
import { getIslerAdet, getClosedJobCount, getMalzemeIhtiyacAdet, getYorumAdet, getUyariAdet } from 'src/utils/storage/NavBarAdet';
import { getUser } from 'src/utils/Common';
import icons from 'src/utils/icons';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import { useDispatch, useSelector } from 'react-redux'
import { setMenu } from 'src/store/actions/testActions';


const functionMap = {
  getIslerAdet: () => getIslerAdet(),
  getClosedJobCount: () => getClosedJobCount(),
  getMalzemeIhtiyacAdet: () => getMalzemeIhtiyacAdet(),
  getYorumAdet: () => getYorumAdet(),
};

const NavConfig = () => {
  const [menuItems, setMenuItems] = useState([]);
  const SessionUser = getUser();
  const { t } = useTranslation('navigation');
  const dispatch = useDispatch();
  const isOnline = useSelector(state => state.status?.isOnline);


  useEffect(() => {
    const fetchMenuItems = async () => {
      try {
        const response = await axios.get(`/GetAuthorizedMenus/${SessionUser.TechnicianId}/4`);
        const data = response.data;

        if (Array.isArray(data)) {
          setMenuItems(data.filter(x => x.Position === 0));
          dispatch(setMenu(data.filter(x => x.Position === 1)));

        } else {
          console.error('Menu items API response is not an array:', data);
        }
      } catch (error) {
        console.error('Error fetching menu items', error);
      }
    };

    fetchMenuItems();
  }, [SessionUser.TechnicianId]);


  const colorsArray = [colors.green[500], colors.red[500], colors.blue[500], '#8b8b00']; // Renk dizisi


  const generateMenu = (menuItems) => {
    return {
      subheader: t('subheader'),
      items: menuItems.map((item, index) => {
        const labelFunction = functionMap[item.FunctionName];

        const labelContent = labelFunction ? labelFunction() : null;

        const color = colorsArray[index % colorsArray.length]; // Döngüsel renk ataması


        return {
          title: t(item.TranslationKey),
          href: item.RouteUrl,
          icon: item.IconName,
          disabled: item.IsDisabledOnOfflineMode && !isOnline,
          label: labelFunction ? (
            <Label color={color} shape="rounded">
              {labelContent?.toString()}
            </Label>
          ) : null,
          items: item.SubMenuItems ? generateMenu(item.SubMenuItems).items : undefined, // Alt menü varsa recursive çağır
        };
      }),
    };
  };


  if (menuItems.length === 0) {
    return null;
  }

  // Menü verisini döndür
  return [generateMenu(menuItems)];
};

export default NavConfig;
